import { render } from "./md-lazy.vue?vue&type=template&id=043e4c44"
import script from "./md-lazy.vue?vue&type=script&lang=js"
export * from "./md-lazy.vue?vue&type=script&lang=js"

import "./md-lazy.vue?vue&type=style&index=0&id=043e4c44&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/md-lazy.vue'],['render',render],['__file',"md-lazy.vue"]])

export default __exports__